// src/EuropeanUnion.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var EuropeanUnion_default = createIcon({
  displayName: "EuropeanUnion",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { d: "M0 4H24V20.8H0V4Z", fill: "#0D3073" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M11.3072 8.86366L12 8.3575L12.6927 8.86366L12.4483 8.01546L13.1208 7.48009L12.2771 7.46204L12 6.625L11.7229 7.46204L10.8791 7.48009L11.5516 8.01546L11.3072 8.86366Z",
        fill: "#FBB43A"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M13.084 8.97375L13.925 8.89909L14.2839 9.70113L14.4761 8.83827L15.3135 8.7277L14.5913 8.26907L14.75 7.3987L14.1114 7.97812L13.372 7.55077L13.6995 8.36749L13.084 8.97375Z",
        fill: "#FBB43A"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M15.3341 10.3787L14.5703 10.0019L15.3921 9.80003L15.4974 8.92079L15.9342 9.67904L16.7631 9.5125L16.2113 10.183L16.6183 10.9593L15.8404 10.6154L15.2631 11.2618L15.3341 10.3787Z",
        fill: "#FBB43A"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M15.3679 11.6726L15.85 12.4L15.3679 13.1274L16.1757 12.8708L16.6856 13.5769L16.7028 12.691L17.5 12.4L16.7028 12.109L16.6856 11.2231L16.1757 11.9292L15.3679 11.6726Z",
        fill: "#FBB43A"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M15.3341 14.4212L15.2631 13.5382L15.8404 14.1846L16.6183 13.8407L16.2113 14.617L16.7631 15.2875L15.9342 15.121L15.4974 15.8792L15.3921 15L14.5703 14.7981L15.3341 14.4212Z",
        fill: "#FBB43A"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M14.2839 15.0989L13.925 15.9009L13.084 15.8263L13.6995 16.4325L13.372 17.2492L14.1114 16.8219L14.75 17.4013L14.5913 16.5309L15.3135 16.0723L14.4761 15.9617L14.2839 15.0989Z",
        fill: "#FBB43A"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12 16.4425L12.6927 15.9363L12.4483 16.7845L13.1208 17.3199L12.277 17.338L12 18.175L11.7229 17.338L10.8791 17.3199L11.5516 16.7845L11.3072 15.9363L12 16.4425Z",
        fill: "#FBB43A"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M10.9159 15.8263L10.075 15.9009L9.71604 15.0989L9.52379 15.9617L8.68642 16.0723L9.40856 16.5309L9.24995 17.4013L9.88851 16.8219L10.6279 17.2492L10.3004 16.4325L10.9159 15.8263Z",
        fill: "#FBB43A"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M8.66575 14.4213L9.4296 14.7981L8.60782 15L8.50252 15.8792L8.06574 15.121L7.23681 15.2875L7.78864 14.617L7.38164 13.8407L8.15947 14.1846L8.73685 13.5382L8.66575 14.4213Z",
        fill: "#FBB43A"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M8.63201 13.1274L8.14995 12.4L8.63201 11.6726L7.8242 11.9292L7.31432 11.2231L7.29713 12.109L6.49995 12.4L7.29713 12.691L7.31432 13.5769L7.8242 12.8708L8.63201 13.1274Z",
        fill: "#FBB43A"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M8.66575 10.3787L8.73685 11.2618L8.15947 10.6154L7.38164 10.9593L7.78864 10.183L7.23681 9.5125L8.06574 9.67904L8.50252 8.92079L8.60782 9.80003L9.4296 10.0019L8.66575 10.3787Z",
        fill: "#FBB43A"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M9.71604 9.70113L10.075 8.89909L10.9159 8.97375L10.3004 8.36749L10.6279 7.55077L9.88851 7.97812L9.24995 7.3987L9.40856 8.26907L8.68642 8.7277L9.52379 8.83827L9.71604 9.70113Z",
        fill: "#FBB43A"
      }
    )
  ] })
});

export {
  EuropeanUnion_default
};
